export const DEPARTMENTS = [
  'Merchandising', 'Buying & Planning', 'Store Operations', 'Visual Merchandising',
  'Design & Product', 'Supply Chain & Logistics', 'E-commerce & Digital',
  'Marketing & Brand', 'Retail Training & L&D', 'HR & People', 'Finance & Costing',
  'Customer Experience', 'IT & Systems', 'Corporate & Strategy'
];

export const WORK_MODES = ['On-site', 'Hybrid', 'Remote'];

export const EMPLOYMENT_TYPES = ['Full-time', 'Part-time', 'Contract', 'Internship', 'Seasonal'];

export const EXPERIENCE_LEVELS = ['Entry (0–1 yr)', 'Junior (1–3 yrs)', 'Mid (3–5 yrs)', 'Senior (5–8 yrs)', 'Lead (8–12 yrs)', 'Director (12+ yrs)'];

export const REGIONS = [
  'Mumbai', 'Delhi NCR', 'Bengaluru', 'Hyderabad', 'Chennai',
  'Kolkata', 'Pune', 'Ahmedabad', 'Jaipur', 'Pan-India', 'HQ Only'
];

export const EDUCATION_LEVELS = [
  "Any Graduate", "B.Com / BBA / BAF", "B.Des / B.FTech",
  "MBA / PGDM", "NIFT / NID Graduate", "Post Graduate preferred"
];

export const SHIFT_TYPES = ['Regular (9-6)', 'Rotational Shifts', 'Flexible Hours', 'Store Hours (as applicable)'];

export const SKILLS_POOL = [
  // Buying & Planning
  'OTB Planning', 'Range Planning', 'WSSI / WSSi Management', 'Category Planning',
  'Trend Forecasting', 'Markdown Optimization', 'Assortment Planning', 'Demand Forecasting',
  // Design & Product
  'Adobe Illustrator', 'Adobe Photoshop', 'CAD Design', 'Tech Pack Preparation',
  'Fabric Knowledge', 'Garment Construction', 'PLM Systems', 'Sample Management',
  // Merchandising
  'NOOS Management', 'Planogram Execution', 'Stock Replenishment', 'MIS Reporting',
  'Retail Math', 'Visual Merchandising', 'Category Management', 'Pricing Strategy',
  // Store Ops
  'Store Operations', 'Loss Prevention', 'Customer Service', 'Team Management',
  'Cash Handling', 'POS Systems', 'Inventory Management', 'Shrinkage Control',
  // Supply Chain
  'Vendor Management', 'Factory Liaison', 'Logistics Coordination', 'Import/Export',
  'Quality Control', 'ERP Systems', 'SAP', 'Warehouse Management',
  // Digital
  'E-commerce Operations', 'Digital Marketing', 'SEO/SEM', 'Omnichannel Retail',
  'Marketplace Management', 'Performance Marketing', 'Social Commerce',
  // Soft Skills
  'Negotiation', 'Data Analysis', 'Excel / Advanced Excel', 'PowerPoint',
  'Communication', 'Leadership', 'Analytical Thinking', 'Fast Fashion Acumen',
  'Brand Alignment', 'Cross-functional Collaboration'
];

export const INTERVIEW_STAGES_OPTIONS = [
  'HR Screening', 'Technical Round', 'Portfolio Review',
  'Case Study', 'Manager Interview', 'Director Interview',
  'CXO Round', 'Assessment / Task', 'Reference Check', 'Offer Discussion'
];

export const JOB_STATUS = ['Draft', 'Active', 'Paused', 'Closed'];

export const APPLICATION_STATUSES = {
  pending:        { label: 'Under Review',         color: 'badge-gold' },
  shortlisted:    { label: 'Shortlisted',           color: 'badge-slate' },
  hr_approved:    { label: 'Round 1 Cleared',     color: 'badge-gold' },
  hod_approved:   { label: 'Round 2 Cleared',   color: 'badge-green' },
  third_round:    { label: 'Round 3 Scheduled', color: 'badge-slate' },
  third_approved: { label: 'All Rounds Cleared', color: 'badge-green' },
  approved:       { label: 'Interview Scheduled',   color: 'badge-green' },
  offer_letter:   { label: 'Offer Letter',       color: 'badge-gold' },
  saved:          { label: 'Saved for Future',      color: 'badge-muted' },
  rejected:       { label: 'Not Proceeding',        color: 'badge-red' }
};

export const PERKS_OPTIONS = [
  "Employee Discount on Brand", "ESOP / Profit Sharing", "Health Insurance",
  "Flexi Hours", "Learning & Development Budget", "Paternity / Maternity Leave",
  "Annual Wardrobe Allowance", "Relocation Assistance", "Performance Bonus",
  "5-Day Work Week", "Hybrid Work Option", "Free Meals / Cafeteria",
  "Gratuity", "International Exposure", "Fast-Track Growth"
];
